import React from 'react';
import { CustomButton } from '../../../../components';

interface AlertFooterProps {
  step?: number;
  setStep: (step: number) => void;
  setOpenNotificationModal: (open: boolean) => void;
  text?: string;
  isSidePannel?: boolean;
  isFormValid?: boolean;
}

/**
 * Footer component for notification modal
 *
 * @param step - Current step number (default: 1)
 * @param setStep - Function to update step
 * @param setOpenNotificationModal - Function to control modal visibility
 * @param text - Submit button text
 * @param isSidePannel - Whether component is in side panel (default: false)
 */
const AlertFooter: React.FC<AlertFooterProps> = ({
  step = 1,
  setStep,
  setOpenNotificationModal,
  text,
  isSidePannel = false,
  isFormValid,
}) => {
  return (
    <div
      className={`notification-modal-footer  ${isSidePannel ? 'sidepannel-footer' : ''}`}
    >
      <CustomButton
        text={'Cancel'}
        bgColor='transparent'
        color='var(--text-primary)'
        fontSize='14px'
        fontWeight='600'
        boxShadow='none'
        height='36px'
        onClick={() => {
          if (step === 3) {
            setStep(2);
          } else {
            setOpenNotificationModal(false);
          }
        }}
      />
      {step !== 3 && (
        <CustomButton
          htmlType='submit'
          text={text}
          bgColor='#000'
          color='#fff'
          fontSize='14px'
          fontWeight='600'
          height={isSidePannel ? '48px' : '36px'}
          borderRadius='8px'
          padding='0 32px'
          isFormValid={isFormValid}
        />
      )}
      {step === 3 && (
        <CustomButton
          text={'Add selected types'}
          bgColor='#000'
          color='#fff'
          fontSize='14px'
          fontWeight='600'
          height={isSidePannel ? '48px' : '36px'}
          borderRadius='8px'
          padding='0 32px'
          onClick={() => setStep(2)}
        />
      )}
    </div>
  );
};

export default AlertFooter;
